import { Directive, HostListener, Input, Renderer2, ElementRef, AfterViewInit, inject } from '@angular/core';
import { NgControl } from '@angular/forms';
import { formatFEIN } from '../../constants';

@Directive({ selector: '[appFEINInputMask]' })
export class FEINInputMaskDirective implements AfterViewInit {
     ngControl = inject(NgControl);
     private renderer = inject(Renderer2);
     private elem = inject(ElementRef);


     @Input() appFEINInputMask: boolean;

     ngAfterViewInit(): void {
     	if (this.appFEINInputMask) {

     		this.renderer.setAttribute(this.elem.nativeElement, 'maxlength', '10');

     		if (!this.elem.nativeElement.hasAttribute('placeholder') || (this.elem.nativeElement.hasAttribute('placeholder') && this.elem.nativeElement.getAttribute('placeholder').length === 0)) {
     			this.renderer.setAttribute(this.elem.nativeElement, 'placeholder', 'xx-xxxxxxx');
     		}
     		else {
     			this.renderer.setAttribute(this.elem.nativeElement, 'placeholder', this.elem.nativeElement.getAttribute('placeholder') + ': xx-xxxxxxx');
     		}
     	}
     }

     @HostListener('ngModelChange', ['$event'])
     onModelChange(event: Event): void {
     	if (this.appFEINInputMask) {
     		this.onInputChange(event as any, false);
     	}
     }

     @HostListener('keydown.backspace', ['$event'])
     keydownBackspace(event: Event): void {
     	if (this.appFEINInputMask) {
     		this.onInputChange((event.target as HTMLInputElement).value, true);
     	}
     }


     onInputChange(event: string, backspace: boolean): void {
     	let newVal = event.replace(/\D/g, '');
     	if (backspace && newVal.length <= 3) {
     		newVal = newVal.substring(0, newVal.length - 1);
     	}

     	newVal = formatFEIN(newVal);

     	this.ngControl.valueAccessor.writeValue(newVal);
     }
}
